/**
 * Die abgeleitete „M"-Klassifikation einer Artikelnummer - Spec Zeile 644, „Abgeleitete
 * Klassifikationen": *„M" (manuelle Artikel): `cArtNr` beginnt mit `x`.*
 *
 * ================= DIE ZWEI M =================
 *
 * Sie heissen gleich und meinen Verschiedenes; beide bleiben nebeneinander bestehen (so schon der
 * Kopfkommentar von `backend/src/jtl/artikel.ts`):
 *
 *   JTL-seitig   Die Artikelnummer beginnt mit `x`. Eine Eigenschaft des ARTIKELS, aus den
 *                Stammdaten abgeleitet, nirgends gespeichert.
 *   tool-eigen   `order_item_extras.manual`, das Ankreuzfeld „Manual / Box - Warenwert 0"
 *                (index.html:8004, :9813). Eine Eigenschaft DIESER POSITION in DIESER Bestellung.
 *
 * Der Bestand kennt nur das zweite und setzt es aus dem WARENWERT: `unit === 0 && amount === 0`
 * (index.html:11570). Dass die X-Artikel dabei zuverlaessig als M herauskommen, ist eine FOLGE -
 * sie stehen in der PI immer mit 0 - und nicht die Regel selbst.
 *
 * ================= WAS DIESES MODUL TUT, UND WAS AUSDRUECKLICH NICHT =================
 *
 * Es liefert einen VORSCHLAG fuer das tool-eigene Kennzeichen, wenn ein Artikel ausgewaehlt wird.
 * Es erzwingt nichts und speichert nichts: der Nutzer kann das Kaestchen sofort wieder ausraeumen,
 * und was gespeichert wird, ist ausschliesslich seine Entscheidung. Genau diese Bauform sieht die
 * Spec zwei Zeilen weiter fuer FOC vor - „`fEKNetto = 0` aus JTL wird beim Einlesen als
 * FOC-Kandidat vorgeschlagen, aber nicht erzwungen" (Zeile 646-649).
 *
 * Solange der PI-Import fehlt (`lib/parsers/`, eigener Plan), ist dies der einzige Weg, auf dem die
 * X-Artikel ohne Handarbeit als M in eine Bestellung kommen.
 *
 * ================= WARUM DIE REGEL HIER NOCH EINMAL STEHT =================
 *
 * Sie steht im Backend (`jtl/artikel.ts#istManuellerArtikel`) und wird dort in `leseArtikel`
 * mitgeliefert - aber die Artikel-SUCHE liefert sie nicht, und genau aus ihrer Trefferliste waehlt
 * die Anlagemaske. Der Vorschlag entsteht also im Browser, aus der Artikelnummer, die ohnehin schon
 * da ist; ein zweiter Abruf je Treffer waere teurer als die Regel selbst. Dass beide Fassungen
 * dasselbe sagen, prueft `test/komponenten/lib/manuelleArtikel.test.ts` gegen die Backend-Funktion.
 */

/**
 * Beginnt die Artikelnummer mit `x` (Gross-/Kleinschreibung unerheblich)?
 *
 * Beschneidet vorher - anders als das Backend, und bewusst: dort kommt der Wert aus der Spalte
 * `cArtNr`, hier aus einem Eingabefeld bzw. einer Trefferliste. Ein fuehrendes Leerzeichen ist da
 * ein Tippfehler und keine Aussage ueber den Artikel.
 */
export function istManuellerArtikel(artikelNummer: unknown): boolean {
  return /^x/i.test(String(artikelNummer ?? "").trim());
}
